<!-- HEADER BOTONERA -->
<form [formGroup]='formData' (ngSubmit)="buscar()">
  <div class="card mt-2 mb-2 wow">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        display: flex;
        align-items: center;
      ">
        <h4>Buscar combos</h4>
        <button type="button" mdbBtn color="info" (click)="abrirModalAgregarCombo()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col-2">
            <div class="md-form">
              <input value="" type="text" id="codigoProducto" class="form-control" placeholder=""
                formControlName="rutCliente" #codigoProducto />
              <label for="codigoProducto">Rut cliente</label>
            </div>
          </div>
          <div class="col" style="
            display: flex;
            align-items: center;
            justify-content: start;
            padding-bottom: 2%;
          ">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccionarCliente()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>

            <button mdbBtn type="button" class="" color="info" mdbWavesEffect
              (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
              ({{clientesSeleccionados.length | numerico}}) Seleccionados
            </button>

            <!-- <h6 class="text-info" *ngIf="clienteSeleccionado">
              {{ clienteSeleccionado.nombre }}
            </h6> -->
            <!-- <h6 class="text-info" *ngIf="clientesSeleccionados">
              {{ clientesSeleccionadosFormatted }}
            </h6> -->
          </div>

          <div class="col">
            <div class="row">
              <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha inicio'" required
                    formControlName='fechaInicio'>
                  </mdb-date-picker>
                </div>
              </div>

              <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaFinal" [placeholder]="'Fecha final'" required
                    formControlName='fechaFin'>
                  </mdb-date-picker>
                </div>
              </div>

              <div class="col" style="
              font-size: 14px;
              font-weight: bold;
              padding-top:1%">
               <span>Estados:</span>
               <div class="form-check">
                 <input class="form-check-input" type="radio" mdbInput id="EstActivoCombo" [value]="RO_EstadoActivoCombo" formControlName="estadoActCombo" checked>
                 <label class="form-check-label" for="EstActivoCombo">
                   Activo
                 </label>
               </div>
               <div class="form-check">
                 <input class="form-check-input" type="radio" mdbInput id="EstInactivoCombo" [value]="RO_EstadoInactivoCombo" formControlName="estadoActCombo">
                 <label class="form-check-label" for="EstInactivoCombo">
                   Inactivo
                 </label>
               </div>
             </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="submit" size="sm" color="secondary" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- LISTADO -->
<div class="card mb-2 wow">
  <div class="card-body" *ngIf="listaCombos">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <!-- <th scope="col">Nro.</th> -->
          <th scope="col">Código</th>
          <th scope="col">Descripción</th>
          <th scope="col">Desde</th>
          <th scope="col">Hasta</th>
          <th scope="col">Estado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="100%" style="text-align: center">
            <mdb-spinner spinnerColor="blue"></mdb-spinner>
          </td>
        </tr>
        <tr *ngIf="!loading && listaCombos?.length === 0">
          <td colspan="100%" style="text-align: center">
            No se encontró información
          </td>
        </tr>
        <tr *ngFor="let combo of listaCombos; trackBy: trackByComboCodigo">
          <!-- <td>1</td> -->
          <td>{{ combo.sku }}</td>
          <td>{{ combo.descripcion }}</td>
          <td>{{ combo.fecha_inicio_combo | fecha }}</td>
          <td>{{ combo.fecha_caducidad_combo | fecha }}</td>
          <td>
            <mdb-badge pill="true" success="true" *ngIf='combo.activo'>Activo</mdb-badge>
            <mdb-badge pill="true" danger="true" *ngIf='!combo.activo'>Inactivo</mdb-badge>
          </td>
          <td>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
              placement="right" (click)="ver(combo)">
              <mdb-icon fas icon="eye"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Editar" placement="right" (click)="editarCombo(combo)"
              [disabled]="!combo.permiteEdicionCombo || !combo.activo">
              <mdb-icon fas icon="pen"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Desactivar" placement="right" (click)="confirmDesactivar(combo.codigo)"
              [disabled]="!combo.permiteEdicionCombo || !combo.activo">
              <mdb-icon fas icon="ban"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Reservar Inventario" placement="right" (click)="reserva(combo)">
              <mdb-icon fas icon="sun"></mdb-icon>
            </button>
          </td>
        </tr>
      </tbody>
      <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="listaCombos?.length > 0"></app-pagination>
    </table>
  </div>
</div>


<!-- MODAL Agregar Combo -->
<app-modal-addedit-combo [permiteUnidadNegocio]="permiteUnidadNegocio"
  [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio" (onSuccess)="onComboSaved()"></app-modal-addedit-combo>

<!-- MODAL Reserva Combo -->
<app-modal-reserva-combo></app-modal-reserva-combo>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT"
  (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>


<app-modal-confirm title="Desactivar combo" contentText="¿Desea desactivar el combo?">
</app-modal-confirm>

<app-modal-show-clientes>
</app-modal-show-clientes>
